import React, { useCallback, useEffect } from 'react'
import Hero from './screens/Hero'
import SecurityAndPrivacy from './screens/SecurityAndPrivacy'
import WhatYouGet from './screens/WhatYouGet'
import OurTechnologies from './screens/OurTechnologies'
import ImageGridThree from './screens/ImageGridThree'
import RoadmapList from './screens/RoadmapList'
import AppStoreRating from './screens/AppStoreRating'
import ReviewSlider from './screens/ReviewSlider'
import { getCountryCode } from '@/helpers/getCountryCode'
import { saveFbcToLocalStorage } from '@/helpers/queryParams'
import { useSearchParams } from 'react-router-dom'
import { trackPageView, trackViewContent } from '@/helpers/facebookPixelEvents'

export const Intro = ({ isWhitePage }: { isWhitePage?: boolean }) => {
  const [searchParams] = useSearchParams()
  const title = searchParams.get('headline') ?? ''
  const storeCountryDetails = useCallback(async () => {
    const countryData = await getCountryCode()
    localStorage.setItem('countryCode', countryData?.country || 'US')
    localStorage.setItem('postalCode', countryData?.postal || '90071')
    localStorage.setItem('ip', countryData?.ip || '')
    localStorage.setItem('isWhitePage', isWhitePage ? 'true' : 'false')
  }, [])

  useEffect(() => {
    storeCountryDetails()
    saveFbcToLocalStorage(searchParams)
    trackPageView()
    trackViewContent()
  }, [])

  return (
    <>
      <Hero title={title} isWhitePage={isWhitePage} />
      <SecurityAndPrivacy />
      <WhatYouGet />
      <OurTechnologies isWhitePage={isWhitePage} />
      <ReviewSlider />
      <ImageGridThree />
      <RoadmapList isWhitePage={isWhitePage} />
      <AppStoreRating isWhitePage={isWhitePage} />
    </>
  )
}
